import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../service/admin.service";
import {LoadingController, ModalController, NavParams, ToastController} from "@ionic/angular";
import {AuthService} from "../../service/auth.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Constant} from "../../shared/model/Constant";

@Component({
  selector: 'app-manage-modules',
  templateUrl: './manage-modules.component.html',
  styleUrls: ['./manage-modules.component.scss'],
})
export class ManageModulesComponent implements OnInit {
  modules: any;
  assignedModules: any[] = [];
  loading: any;
  formAccess: FormGroup;
  profile: any;
  constructor(private adminService: AdminService,
              private loadingController: LoadingController,
              private authService: AuthService,
              private formBuilder: FormBuilder,
              public navParams: NavParams,
              public toastController: ToastController,
              public modalController: ModalController,
  ) {
  }

  async ngOnInit() {
    this.profile = this.navParams.get('profile');
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.buildForm();
    await this.getAllModules();
    this.getAccessByProfile();
  }

  async close() {
    await this.modalController.dismiss();

  }

  addModule() {
    this.loading.present();
    this.authService.createAccess(this.formAccess.value).subscribe((res: any) => {
      if (res && res.accessId) {
        this.presentToast('Módulo asociado exitosamente');
        this.close();
      }
      this.loading.dismiss();
    });
  }

  getAllModules() {
    this.loading.present();
    this.adminService.getModule().subscribe((res => {
      this.modules = res;
      this.loading.dismiss();
    }));
  }

  buildForm() {
    this.formAccess = this.formBuilder.group({
      profileId: [this.profile.profileId, Validators.required],
      menuId: ['', Validators.required],
      userId: [JSON.parse(localStorage.getItem(Constant.userId)), Validators.required]
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  getAccessByProfile() {
    this.loading.present();
    this.authService.getAccessByProfile(this.profile.profileId).subscribe((res: any) => {
      if (res && res.length > 0) {
        res.forEach(item => {
          item.name = this.modules.filter(i => i.menuId === item.menuId)[0].name;
        });
        this.assignedModules = res;
      } else {
        this.assignedModules = [];
      }
      this.loading.dismiss();
    });
  }

  deleteAccess(item: any) {
    this.authService.deleteAccess(item.accessId).subscribe((res: any) => {
      this.presentToast('Módulo eliminado exitosamente');
      this.getAccessByProfile();
    });
  }
}
